import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import WithRouter from 'custom/withRouter';
import { getDevices } from 'actions/EntityActions';
import LOOKUP from 'constants/lookup';
import { deviceListCrumb } from 'utils/breadcrumbInfo';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import SelectInput from 'screens/components/basic/SelectInput';
import PageHeader from 'screens/components/basic/PageHeader';
import Button from 'screens/components/basic/Button';
// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';

class DeviceList extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.getDevices({
            branchId: this.props.branchId,
            status: "1"
        });
    }

    redirectToAddDevice = () => {
        this.props.navigate("/manage/device/add");
    }

    redirectToEditDevice = (id) => {
        this.props.navigate(`/manage/device/edit/${id}`);
    }

    handleFilterChange = (value) => {
        const model = {
            branchId: this.props.branchId,
            status: value
        };
        this.props.getDevices(model);
    };

    render() {

        const listDevices = (this.props.devices || []).map((item) => {
            return {
                // DeviceNumber: (<Link className="edit-link" to={`/manage/device/edit/${item.id}`}>{item.deviceNumber}</Link>),
                DeviceType: (<Link to={`/manage/device/edit/${item.id}`}>{item.deviceTypeName}</Link>),
                Role: item.deviceRoleName,
                WorkStation: item.deviceWorkStationName,
                IPAddress: item.ipAddress,
                Balance: `$${item.balance}`,
                Status: (item.status !== "Online" ? <p className="statusIconRed m-0">{item.status}</p> :
                    <p className="statusIconGreen m-0">{item.status}</p>),
                Icons: (
                    <Button
                            type="IconEditButton"
                            mini={true}
                            onTouchTap={() => this.redirectToEditDevice(item.id)} />
                )
            };
        });

        return (
            <Grid headerContent={deviceListCrumb}>
                <PageHeader title={LOOKUP.menu.manage.items.device.text} />
                <div className="SearchBarContainer">
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6" style={{ maxWidth: '200px' }}>
                        <SelectInput
                            className="selectInput"
                            name="DeviceListStatus"
                            floatingLabelText="Filter by Status"
                            value={this.props.status}
                            defaultValue={"1"}
                            onChange={this.handleFilterChange}
                            options={[
                                { value: "0", text: "All" },
                                { value: "1", text: "Active Only" }
                            ]}
                        />
                    </div>
                    <div className="pull-right mt-1 col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">
                        <Button
                            type="AddButton"
                            label="ADD NEW DEVICE"
                            className="bg-light-green site_1-2rem"
                            onTouchTap={this.redirectToAddDevice} />
                    </div>
                </div>
                <div className="list-table">
                    <GenericTable
                        className="table_center tableHeaderwhiteColorFont"
                        tableBodyClassName="registers-table"
                        multiSelectable={false}
                        enableSelectAll={false}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        selectable={false}
                        stripedRows={true}
                        columns={LOOKUP.device.tableColumns}
                        rows={listDevices} />
                </div>
            </Grid>
        );
    }
}

function mapStatetoProps(state) {
    return {
        devices: state.entity.devicesList,
        branchId: state.common.branchId,
        status: state.form['DeviceListStatus']
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        getDevices: (model) => dispatch(getDevices(model))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(DeviceList));
